// extracted by mini-css-extract-plugin
export default {"title":"Deals_title__xAF+a","note":"Deals_note__l7KDG","space":"Deals_space__ny4sN"};